import { FormGroup, AbstractControl, ValidatorFn } from '@angular/forms';
import { debounceTime, takeWhile } from 'rxjs/operators';

export class FormValidator {

// Variable que contien los controles del formulario
// que no han pasado alguna de sus validaciones.
formErrorMessages: {};

// Variable que contiene el listado de mensajes asociados a cada
// una de las validaciones que se van a aplicar en el formulario.
templateMessages: {};

// Variable que controla la activación/desactivación de las suscripciones del formulario.
validatorActive: boolean;

 constructor() {
    this.formErrorMessages = {};
    this.validatorActive = true;
 }

 // -----------------------------------
 //   FUNCIONES GENÉRICAS DE CONTROL
 // -----------------------------------
 subscribeFormGroup(projectFormIn: FormGroup) {
    Object.keys(projectFormIn.controls).forEach(key => {
      console.log(' -->-> projectForm key: ' + key);

      // Se inicializa la varible que va a contener todos los
      // mensajes de error de los campos del formulario.
      this.formErrorMessages[key] = '';

      // Se realiza la subscripción del correspondiente controlador.
      const auxControl = projectFormIn.get(key);
      auxControl.valueChanges.pipe(
        debounceTime(500), // Tiempo de espera antes de lanzar la acción.
        takeWhile(() => this.validatorActive)
        ).subscribe(
          value => this.setMessage(auxControl, key)
          );
    });
 } // End function newFormControl

 // Actualiza todos los mensajes para las validaciones.
 setTemplateMessages(menssagesIn: any) {
    this.templateMessages = menssagesIn;
 }

 // Actualiza el mensaje de un control concreto del formulario.
 setControlMessage(controlNameIn: string, menssageIn: string) {
    this.templateMessages[controlNameIn] = menssageIn;
 }

 // Actualiza todos los mensajes para las validaciones.
 resetTemplateMessages() {
    this.templateMessages = {};
 }

 // Desactiva/Activa las subscripciones de los controles del formulario
 setValidatorActive(value: boolean) {
   this.validatorActive = value;
 }

 private setMessage(c: AbstractControl, name: string): void {
   //  console.log(' --> * AbstractControl del control de formulario = ' + name);

    this.formErrorMessages[name] = '';
    if ((c.touched || c.dirty) && c.errors) {
        // console.log(' --> * Errores del formulario: ');
        // console.log(c.errors);
        this.formErrorMessages[name] = Object.keys(c.errors).map(
        key => {

            this.formErrorMessages[name] = this.templateMessages[key];
            // console.log(' --> * Error key: ' + key);
            // console.log(this.formMessages[name]);

            return this.formErrorMessages[name];
        }).join(' ');
    }
 } // End function setMessage

// --------------------------------------------
//      VALIDADORES GENÉRICOS CUSTOMIZADOS
// --------------------------------------------
/*
 // Validador sin parámetros.
 myValidator(c: AbstractControl): {[key: string]: boolean} | null {
    if (c.value !== null && (isNaN(c.value) || c.value < 1 || c.value > 5)) {
       return {'myValidator': true};
    }
    return null;
 } // End function myValidator

 // Validador con parámetros.
 myParamValidator(min: number, max: number): ValidatorFn {
  return(c: AbstractControl): {[key: string]: boolean} | null  => {
      if (c.value !== null && (isNaN(c.value) || c.value < min || c.value > max)) {
        return {'myParamValidator': true};
      }
      return null;
  };
 } // End function myParamValidator
*/
} // End class FormValidator
